export default __webpack_public_path__ + "static/media/playstore-badge.138c3e77.svg";